import { GridPrefKey, savePrefParams } from './types';

export const savePrefHandlerCallback = (params: savePrefParams, canBeSaved: boolean, localStorageKey: string) => {
	if (!canBeSaved) return;

	const currentGridState = localStorage.getItem(localStorageKey);
	const cols = params.detail.columnApi.getAllGridColumns();
	const colsPositionObject = cols.map((col, index: number) => {
		return { colId: col.getId(), index };
	});

	const newColumnOrderPrefState = {
		[GridPrefKey.ORDER_STATE]: JSON.stringify(colsPositionObject),
		[GridPrefKey.COL_STATE]: JSON.stringify(params.detail.columnApi.getColumnState()),
	};

	if (currentGridState) {
		const currentGridStateParsed = JSON.parse(currentGridState);
		const newGridState = {
			...currentGridStateParsed,
			...newColumnOrderPrefState,
		};

		localStorage.setItem(localStorageKey, JSON.stringify(newGridState));
		return;
	}

	localStorage.setItem(localStorageKey, JSON.stringify(newColumnOrderPrefState));
};

export const setGridPerferencesHandlerCallback = (
	params: savePrefParams,
	localStorageKey: string,
	setCanBeSaved: (val: boolean) => void,
) => {
	const gridPref = localStorage.getItem(localStorageKey);

	if (!gridPref) {
		setCanBeSaved(true);
		return;
	}

	const { colState, orderState } = JSON.parse(gridPref);

	if (colState) {
		params.detail.columnApi.applyColumnState({
			state: JSON.parse(colState),
		});
	}

	if (orderState) {
		const orderArr = JSON.parse(orderState);
		orderArr.forEach((item: { colId: string; index: number }) => {
			params.detail.columnApi.moveColumn(item.colId, item.index);
		});
	}

	setCanBeSaved(true);
};
